export default "__VITE_ASSET__6GzN43ZZ__"